/* Marinelie — Shop All, Filter nach Entwurf 7a (F4).

   Zwei Achsen. Was das Skript zu tun hat:

   1. Bei Karte F die Schublade von links auf und zu; bei den anderen
      Stilen die Blaetter unter der Leiste, immer nur eines.
   2. Auswahl setzen. Jede Achse haelt eine Liste: in der Schublade darf
      man mehrere Werte waehlen (Otton, 11.10.2026: "man soll auch mehrere
      anlaesse auswaehlen koennen"). Innerhalb einer Achse gilt ODER —
      wer "fuer abends" und "fuer den tag" nimmt, will beides sehen, nicht
      nur, was beides zugleich ist. Zwischen den Achsen gilt UND. Die
      Blaetter der anderen Stile bleiben Einzelwahl: ein Tipp setzt die
      Liste auf genau diesen einen Wert.
   3. Karten aus- und einblenden, Trefferzahl schreiben.
   4. Zwischen Kapitelrhythmus und flachem Raster umschalten. Sobald
      gefiltert wird, verschwinden die Kapitel: ein Aufmacher, dem der
      Slider weggefiltert wurde, waere ein halbes Kapitel.
   5. Je Zeile zeigen, wie viele Treffer dieser Wert zusammen mit der Wahl
      der ANDEREN Achse haette. Werte ohne Treffer stehen mit "—" da und
      bleiben waehlbar — wer sie trotzdem nimmt, landet auf der Leerseite.
   6. Die Auswahl in die URL schreiben, damit ein Link den Zustand
      wiederherstellt und der Zurueck-Knopf des Browsers etwas zu tun hat.

   Gezaehlt wird immer auf dem flachen Raster: dort steht jeder Duft genau
   einmal. Im Kapitelstrom kann derselbe Duft zweimal haengen — meistgekauft
   und dauerhaft —, das wuerde die Zahl aufblasen. */

(function () {
  'use strict';

  var wurzel = document.querySelector('[data-dg]');
  if (!wurzel || wurzel.dataset.dgBereit) return;
  wurzel.dataset.dgBereit = '1';

  /* "alle" gibt es nur noch als Zeile in den Blaettern der anderen Stile.
     Im Zustand heisst "alle" eine leere Liste. */
  var ALLE = 'alle';
  var ACHSEN = ['anlass', 'familie'];
  var wahl = { anlass: [], familie: [], suche: '' };

  var flach = wurzel.querySelector('[data-dg-flach]');
  var strom = wurzel.querySelector('[data-dg-strom]');
  var leer = wurzel.querySelector('[data-dg-leer]');
  var zahlFeld = wurzel.querySelector('[data-dg-zahl]');
  var zurueck = wurzel.querySelectorAll('[data-dg-zurueck]');
  var suchfeld = wurzel.querySelector('[data-dg-suche]');
  var flachKarten = flach ? [].slice.call(flach.querySelectorAll('[data-dg-karte]')) : [];

  var lade = wurzel.querySelector('[data-dg-lade]');
  var panel = lade ? lade.querySelector('[data-dg-panel]') : null;
  var ladeKnopf = wurzel.querySelector('[data-dg-lade-auf]');
  var anzahlFeld = wurzel.querySelector('[data-dg-anzahl]');
  var zeigen = wurzel.querySelector('[data-dg-zeigen]');

  /* Den Namen einmal je Karte merken, kleingeschrieben. Bei jedem Tastendruck
     erneut aus dem DOM zu lesen und zu senken waere elfmal Arbeit fuer
     dasselbe Ergebnis. */
  flachKarten.forEach(function (k) {
    var n = k.querySelector('.ml-dg__name');
    k.dgName = (n ? n.textContent : '').toLowerCase();
  });

  function merkmal(karte, achse) {
    return ' ' + (karte.getAttribute('data-' + achse) || '') + ' ';
  }

  /* Leere Liste = keine Einschraenkung. Sonst genuegt ein Wert (ODER). */
  function trifftAchse(karte, achse, liste) {
    if (!liste.length) return true;
    var m = merkmal(karte, achse);
    for (var i = 0; i < liste.length; i++) {
      if (m.indexOf(' ' + liste[i] + ' ') > -1) return true;
    }
    return false;
  }

  function trifft(karte, a, f) {
    return trifftAchse(karte, 'anlass', a) && trifftAchse(karte, 'familie', f);
  }

  /* Die Suche liegt neben den beiden Achsen, nicht in ihnen: sie schraenkt
     zusaetzlich ein. Wer "9pm" tippt und "für abends" gewaehlt hat, sieht
     was beides ist. In den Trefferzahlen der Zeilen zaehlt sie mit,
     damit die Zahl im Blatt nicht etwas anderes verspricht als die Liste. */
  function trifftMitSuche(karte, a, f) {
    if (!trifft(karte, a, f)) return false;
    if (!wahl.suche) return true;
    return karte.dgName.indexOf(wahl.suche) > -1;
  }

  function zaehlen(a, f) {
    var n = 0;
    for (var i = 0; i < flachKarten.length; i++) {
      if (trifftMitSuche(flachKarten[i], a, f)) n += 1;
    }
    return n;
  }

  function gefiltert() {
    return wahl.anlass.length > 0 || wahl.familie.length > 0 || wahl.suche !== '';
  }

  /* ------------------------------------------------------------ BLAETTER */

  function blattZu() {
    wurzel.querySelectorAll('[data-dg-blatt]').forEach(function (b) { b.hidden = true; });
    wurzel.querySelectorAll('[data-dg-oeffnet]').forEach(function (k) {
      k.setAttribute('aria-expanded', 'false');
      k.classList.remove('is-offen');
    });
  }

  function blattAuf(achse) {
    var blatt = wurzel.querySelector('[data-dg-blatt="' + achse + '"]');
    if (!blatt) return;
    var warOffen = !blatt.hidden;
    blattZu();
    if (warOffen) return;
    blatt.hidden = false;
    var knopf = wurzel.querySelector('[data-dg-oeffnet="' + achse + '"]');
    if (knopf) {
      knopf.setAttribute('aria-expanded', 'true');
      knopf.classList.add('is-offen');
    }
  }

  /* ---------------------------------------------------------- SCHUBLADE

     Dasselbe Verhalten wie das Menue: das Panel beginnt unter dem
     klebenden Kopf und reicht bis an den unteren Rand, daneben liegt die
     Seite unscharf. Die Unterkante des Kopfes wird beim Oeffnen gemessen
     und nicht aus --header-height genommen: ganz oben steht noch die
     Rille ueber dem Kopf (Unterkante 91 statt 68 px am Telefon), und
     ein Kopf, der sich beim Scrollen versteckt, haette sonst eine Luecke
     ueber der Schublade gelassen. */
  var ladeOffen = false;
  /* Der erste Tipp nach dem Oeffnen legt einen Eintrag im Verlauf an,
     jeder weitere ueberschreibt ihn. Sonst braucht der Zurueck-Knopf so
     viele Klicks, wie Kaestchen angetippt wurden. */
  var ersterTipp = true;

  function ladeLage() {
    var kopf = document.querySelector('.section-header');
    var oben = kopf ? Math.max(0, Math.round(kopf.getBoundingClientRect().bottom)) : 0;
    lade.style.setProperty('--dg-lade-oben', oben + 'px');
    lade.style.top = oben + 'px';
    /* Im Dunkelmodus traegt der body einen filter (ml-dunkel.css). Damit
       rechnet position: fixed gegen den body statt gegen das Fenster, und
       die Schublade stuende am Seitenanfang. Einmal messen und um den
       Versatz zuruecksetzen — solange sie offen ist, scrollt nichts. */
    var versatz = Math.round(lade.getBoundingClientRect().top) - oben;
    if (versatz) lade.style.top = (oben - versatz) + 'px';
  }

  function ladeAuf() {
    if (!lade || ladeOffen) return;
    ladeOffen = true;
    ersterTipp = true;
    blattZu();
    ladeLage();
    /* is-offen sperrt auch das Scrollen der Seite (ml-duftgrid.css,
       html:has(.ml-dgl.is-offen)). */
    lade.classList.add('is-offen');
    if (ladeKnopf) ladeKnopf.setAttribute('aria-expanded', 'true');
    if (panel) panel.focus({ preventScroll: true });
  }

  function ladeZu(fokusZurueck) {
    if (!lade || !ladeOffen) return;
    ladeOffen = false;
    lade.classList.remove('is-offen');
    if (ladeKnopf) {
      ladeKnopf.setAttribute('aria-expanded', 'false');
      if (fokusZurueck !== false) ladeKnopf.focus({ preventScroll: true });
    }
  }

  /* Tab bleibt im Panel, solange es offen ist: hinter dem Schleier liegt
     nichts, was man jetzt erreichen soll. */
  function fokusHalten(e) {
    if (!panel) return;
    var ziele = [].slice.call(panel.querySelectorAll('button')).filter(function (b) {
      return !b.hidden && b.offsetParent !== null;
    });
    if (!ziele.length) return;
    var erstes = ziele[0];
    var letztes = ziele[ziele.length - 1];
    var hier = document.activeElement;
    if (e.shiftKey && (hier === erstes || hier === panel)) {
      e.preventDefault();
      letztes.focus();
    } else if (!e.shiftKey && hier === letztes) {
      e.preventDefault();
      erstes.focus();
    }
  }

  /* -------------------------------------------------------------- ZEICHNEN */

  function zeigenWort(n) {
    if (!zeigen) return;
    if (n === 0) zeigen.textContent = zeigen.getAttribute('data-leer');
    else zeigen.textContent = n + ' ' + zeigen.getAttribute(n === 1 ? 'data-eins' : 'data-viele');
  }

  function zeichnen() {
    var an = gefiltert();
    var treffer = 0;

    for (var i = 0; i < flachKarten.length; i++) {
      var ja = trifftMitSuche(flachKarten[i], wahl.anlass, wahl.familie);
      flachKarten[i].hidden = !ja;
      if (ja) treffer += 1;
    }

    /* Das Raster steht immer — es gibt keinen Kapitelrhythmus mehr, auf
       den umgeschaltet wuerde. Weg ist es nur, wenn nichts uebrig bleibt. */
    /* Ungefiltert steht der Strom mit seinen Gruppen, gefiltert das
       flache Raster. Gezaehlt wird immer auf dem Raster: dort steht jeder
       Duft genau einmal. */
    if (flach) flach.hidden = !an || treffer === 0;
    if (strom) strom.hidden = an;
    if (leer) leer.hidden = !an || treffer > 0;

    if (zahlFeld) {
      zahlFeld.textContent = an
        ? treffer + (treffer === 1 ? ' Duft' : ' Düfte')
        : flachKarten.length + ' im Sortiment';
    }
    zurueck.forEach(function (k) { if (k.hasAttribute('hidden') !== !an) k.hidden = !an; });

    wurzel.querySelectorAll('[data-dg-schild]').forEach(function (s) {
      var achse = s.getAttribute('data-dg-schild');
      s.textContent = wahl[achse].length ? wahl[achse].join(', ') : s.dataset.dgAlle;
    });

    /* Jede Zeile: gewaehlt oder nicht, und wie viele Treffer sie zusammen
       mit der Wahl der anderen Achse haette. Die eigene Achse zaehlt dabei
       nur mit diesem einen Wert — sonst stuende bei jeder Zeile dieselbe
       Zahl wie unten auf dem Knopf. */
    wurzel.querySelectorAll('[data-dg-wahl]').forEach(function (r) {
      var achse = r.getAttribute('data-dg-achse');
      var wert = r.getAttribute('data-dg-wahl');
      var aktiv = wert === ALLE ? wahl[achse].length === 0 : wahl[achse].indexOf(wert) > -1;
      r.classList.toggle('is-aktiv', aktiv);
      if (r.hasAttribute('aria-pressed')) r.setAttribute('aria-pressed', aktiv ? 'true' : 'false');
      var haken = r.querySelector('[data-dg-haken]');
      if (haken) haken.hidden = !aktiv;

      var notiz = r.querySelector('[data-dg-notiz]');
      if (!notiz) return;
      var eigen = wert === ALLE ? [] : [wert];
      var n = achse === 'anlass' ? zaehlen(eigen, wahl.familie) : zaehlen(wahl.anlass, eigen);
      notiz.textContent = n > 0 ? String(n) : '—';
      r.classList.toggle('is-leer', n === 0);
    });

    if (anzahlFeld) {
      var gewaehlt = wahl.anlass.length + wahl.familie.length;
      anzahlFeld.textContent = '(' + gewaehlt + ')';
      anzahlFeld.classList.toggle('is-leer', gewaehlt === 0);
    }
    zeigenWort(treffer);
  }

  /* ------------------------------------------------------------------ URL

     Mehrere Werte stehen als Kommaliste in einem Parameter:
     ?anlass=fuer+abends,fuer+den+tag&familie=gourmand. Ein Komma kommt in
     keinem Wert vor — die Anlaesse werden in der Section an Kommas
     getrennt, die Familien sind einzelne Woerter. Alte Links mit einem
     Wert lesen sich damit unveraendert. */
  function urlSchreiben(ersetzen) {
    var u = new URL(window.location.href);
    ACHSEN.forEach(function (achse) {
      if (wahl[achse].length) u.searchParams.set(achse, wahl[achse].join(','));
      else u.searchParams.delete(achse);
    });
    if (!wahl.suche) u.searchParams.delete('q');
    else u.searchParams.set('q', wahl.suche);
    /* searchParams schreibt das Komma als %2C. Lesbar ist der Link nur mit
       dem Komma selbst, und get() liest beides gleich. */
    var s = u.pathname + (u.search || '').replace(/%2C/gi, ',');
    var zustand = { dg: { anlass: wahl.anlass.slice(), familie: wahl.familie.slice(), suche: wahl.suche } };
    if (ersetzen) history.replaceState(zustand, '', s);
    else history.pushState(zustand, '', s);
  }

  function urlLesen() {
    var p = new URLSearchParams(window.location.search);
    ACHSEN.forEach(function (achse) {
      var liste = [];
      (p.get(achse) || '').split(',').forEach(function (roh) {
        var w = roh.trim().toLowerCase();
        /* Nur uebernehmen, was es auf der Seite als Zeile gibt — sonst
           zeigt ein alter Link eine leere Seite ohne erkennbaren Grund. */
        if (!w || w === ALLE || liste.indexOf(w) > -1) return;
        if (wurzel.querySelector('[data-dg-achse="' + achse + '"][data-dg-wahl="' + CSS.escape(w) + '"]')) liste.push(w);
      });
      wahl[achse] = liste;
    });
    /* Ohne Suchfeld (Karte F) bleibt ?q= wirkungslos: eine Suche, die man
       nirgends sieht und nirgends loeschen kann, waere ein stiller Filter. */
    wahl.suche = suchfeld ? (p.get('q') || '').trim().toLowerCase() : '';
    if (suchfeld) suchfeld.value = wahl.suche;
  }

  /* In der Schublade: erster Tipp neuer Eintrag, danach ersetzen. */
  function urlAusLade() {
    urlSchreiben(!ersterTipp);
    ersterTipp = false;
  }

  /* --------------------------------------------------------------- KLICKS */

  wurzel.addEventListener('click', function (e) {
    if (e.target.closest('[data-dg-lade-auf]')) { ladeAuf(); return; }
    if (e.target.closest('[data-dg-lade-zu]')) { ladeZu(); return; }

    var oeffner = e.target.closest('[data-dg-oeffnet]');
    if (oeffner) { blattAuf(oeffner.getAttribute('data-dg-oeffnet')); return; }

    if (e.target.closest('[data-dg-zu]')) { blattZu(); return; }

    if (e.target.closest('[data-dg-zurueck]')) {
      wahl.anlass = [];
      wahl.familie = [];
      wahl.suche = '';
      if (suchfeld) suchfeld.value = '';
      blattZu();
      zeichnen();
      if (ladeOffen) urlAusLade();
      else urlSchreiben(false);
      return;
    }

    var reihe = e.target.closest('[data-dg-wahl]');
    if (!reihe) return;
    var achse = reihe.getAttribute('data-dg-achse');
    var wert = reihe.getAttribute('data-dg-wahl');

    /* Schublade: Kaestchen an und aus, sie bleibt offen. */
    if (lade && lade.contains(reihe)) {
      var stelle = wahl[achse].indexOf(wert);
      if (stelle > -1) wahl[achse].splice(stelle, 1);
      else wahl[achse].push(wert);
      zeichnen();
      urlAusLade();
      return;
    }

    /* Blatt der anderen Stile: Einzelwahl, das Blatt geht zu. */
    wahl[achse] = wert === ALLE ? [] : [wert];
    blattZu();
    zeichnen();
    urlSchreiben(false);
  });

  document.addEventListener('keydown', function (e) {
    if (!ladeOffen) return;
    if (e.key === 'Escape') { ladeZu(); return; }
    if (e.key === 'Tab') fokusHalten(e);
  });

  /* Geht das Menue auf, waehrend die Schublade offen ist, laegen zwei
     Schubladen uebereinander. Die Filterschublade weicht. */
  var menueKasten = document.getElementById('Details-menu-drawer-container');
  if (menueKasten) {
    menueKasten.addEventListener('toggle', function () {
      if (menueKasten.open) ladeZu(false);
    });
  }

  /* Beim Tippen sofort filtern, aber nicht bei jedem Buchstaben einen
     Eintrag in die Verlaufsliste schreiben — sonst braeuchte der
     Zurueck-Knopf zehn Klicks fuer ein Wort. Die Liste wird sofort
     nachgezogen, die URL erst, wenn eine Viertelsekunde nichts kam. */
  if (suchfeld) {
    var wartet = null;
    suchfeld.addEventListener('input', function () {
      wahl.suche = suchfeld.value.trim().toLowerCase();
      blattZu();
      zeichnen();
      clearTimeout(wartet);
      wartet = setTimeout(function () { urlSchreiben(true); }, 250);
    });
  }

  /* Zurueck im Browser: Zustand aus der URL, Schublade zu. Der naechste
     Tipp legt wieder einen eigenen Eintrag an — ein replaceState wuerde
     sonst genau den Eintrag ueberschreiben, auf den man gerade zurueck
     ist. */
  window.addEventListener('popstate', function () {
    urlLesen();
    blattZu();
    ladeZu();
    ersterTipp = true;
    zeichnen();
  });

  /* Das Schild soll beim Zuruecksetzen wieder "Alle" sagen — der Wortlaut
     kommt aus den Einstellungen, deshalb einmal merken statt fest zu
     verdrahten. */
  wurzel.querySelectorAll('[data-dg-schild]').forEach(function (s) {
    s.dataset.dgAlle = s.textContent.trim();
  });

  /* ---------------------------------------------------- GALERIE (KARTE F)

     Die Laufleiste unter dem Bild zeigt "Bild 1 von n" und folgt dem
     Wischen. Gezaehlt wird an der Scrollstelle, nicht an Ereignissen: so
     stimmt sie auch nach Schwung und Einrasten. Die Pfeile liegen in der
     Karte, die ein Link ist — ihr Klick blaettert und darf die Seite
     nicht wechseln. */
  wurzel.querySelectorAll('[data-dg-galerie]').forEach(function (g) {
    var karte = g.closest('.ml-dg__karte');
    var wartet = false;
    g.addEventListener('scroll', function () {
      if (wartet) return;
      wartet = true;
      window.requestAnimationFrame(function () {
        wartet = false;
        var breite = g.clientWidth || 1;
        karte.style.setProperty('--stelle', String(Math.round(g.scrollLeft / breite)));
      });
    }, { passive: true });
  });

  wurzel.addEventListener('click', function (e) {
    var pfeil = e.target.closest('[data-dg-blaettern]');
    if (!pfeil) return;
    e.preventDefault();
    var g = pfeil.parentElement.querySelector('[data-dg-galerie]');
    if (!g) return;
    var schritt = Number(pfeil.getAttribute('data-dg-blaettern')) || 1;
    var ziel = g.scrollLeft + schritt * g.clientWidth;
    /* Am Ende wieder vorn anfangen: ein Pfeil, der nichts mehr tut, liest
       sich wie ein Fehler. */
    if (ziel > g.scrollWidth - g.clientWidth + 1) ziel = 0;
    if (ziel < 0) ziel = g.scrollWidth - g.clientWidth;
    g.scrollTo({ left: ziel, behavior: 'smooth' });
  });

  urlLesen();
  zeichnen();
  urlSchreiben(true);
})();
